/**
 * @generated SignedSource<<4e6343ffe97808b65e8580e657bb96ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BusinessBeneficialOwnerDocumentCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateBeneficialOwnerDocTPayload",
        "kind": "LinkedField",
        "name": "createBeneficialOwnerDocT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BeneficialOwnerDocT",
            "kind": "LinkedField",
            "name": "beneficialOwnerDocT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BusinessBeneficialOwnerDocumentCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateBeneficialOwnerDocTPayload",
        "kind": "LinkedField",
        "name": "createBeneficialOwnerDocT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BeneficialOwnerDocT",
            "kind": "LinkedField",
            "name": "beneficialOwnerDocT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c665ee3a62d80894b314b3feab0d529d",
    "id": null,
    "metadata": {},
    "name": "BusinessBeneficialOwnerDocumentCreateMutation",
    "operationKind": "mutation",
    "text": "mutation BusinessBeneficialOwnerDocumentCreateMutation(\n  $input: CreateBeneficialOwnerDocTInput!\n) {\n  createBeneficialOwnerDocT(input: $input) {\n    beneficialOwnerDocT {\n      bodId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "b0ca78f76b838042b2cb3899df7fea89";

module.exports = node;
